import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/base/SEOMeta';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import CategoryTabs from './components/CategoryTabs';
import PostList from './components/PostList';
import { getPostsByCategory, getCategoryBySlug, posts as allPosts } from '@/mocks/posts';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;
  const categoryPosts = slug ? getPostsByCategory(slug) : allPosts;

  const title = category ? `${category.name} - 海角社区` : '全部分类 - 海角社区';
  const description = category
    ? `${category.description} 浏览海角社区${category.name}分类下的精彩文章，与志同道合的朋友一起交流分享。`
    : '浏览海角社区所有分类的精彩文章，发现感兴趣的内容，加入讨论。';

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title={title}
        description={description}
        keywords={`海角社区,${category ? category.name : '分类'},社区文章,在线论坛`}
        canonicalUrl={`https://baynetwork.github.io/category/${slug || ''}`}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                ...(category
                  ? [{ label: category.name }]
                  : [{ label: '全部分类' }]),
              ]}
            />
            <CategoryTabs activeSlug={slug || ''} />
            <PostList
              posts={categoryPosts}
              categoryName={category?.name || '全部文章'}
              categoryDescription={category?.description || '浏览海角社区所有精彩内容'}
            />
            {categoryPosts.length === 0 && slug && (
              <div className="text-center py-16">
                <p className="text-foreground-600 mb-4">该分类暂无文章</p>
                <Link
                  to="/"
                  className="text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}